// extracted by mini-css-extract-plugin
export default {"wrapper":"colorTabContent_wrapper__IEMsT","mobile":"colorTabContent_mobile__zI3+D","colorInfo":"colorTabContent_colorInfo__ycpze"};